import { render, staticRenderFns } from "./listing-feed-set.vue?vue&type=template&id=6633b7f8&"
import script from "./listing-feed-set.vue?vue&type=script&lang=js&"
export * from "./listing-feed-set.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Umbraco\\Upgrade\\CareFirst\\v16\\Website\\CarersFirst.Shared.FrontEnd\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6633b7f8')) {
      api.createRecord('6633b7f8', component.options)
    } else {
      api.reload('6633b7f8', component.options)
    }
    module.hot.accept("./listing-feed-set.vue?vue&type=template&id=6633b7f8&", function () {
      api.rerender('6633b7f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/app/vue-components/common/listing/listing-feed-set.vue"
export default component.exports